module.exports = __webpack_public_path__ + "img/checkpoints.37970be2.svg";